export default "__VITE_ASSET__tBzbeJMM__"